module.exports = __webpack_public_path__ + "img/null_user.76b1ea2e.png";